import { createFileRoute, redirect } from "@tanstack/react-router";

import { Settings } from "/src/routes/settings/Settings";

export const Route = createFileRoute("/_main/settings")({
  component: Settings,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/settings") {
      throw redirect({ to: "/settings/battery_low" });
    }
  },
});
